import { render, staticRenderFns } from "./UserMetricsTrendChart.vue?vue&type=template&id=2d1af7ba&scoped=true&"
import script from "./UserMetricsTrendChart.vue?vue&type=script&lang=ts&"
export * from "./UserMetricsTrendChart.vue?vue&type=script&lang=ts&"
import style0 from "./UserMetricsTrendChart.vue?vue&type=style&index=0&id=2d1af7ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1af7ba",
  null
  
)

export default component.exports